export const WHITE_COLOR = '#ffffff';
export const BLACK_COLOR = '#0f1c14';
